export default __webpack_public_path__ + "static/Ever-green-ae1917a435f183c562647388ef1f6f1b.mp4";